import { jsx, jsxs } from "react/jsx-runtime";
import { Logo } from "@seek/logo";
import { useTranslations, useLanguage } from "@vocab/react";
import { Box } from "braid-design-system";
import { analyticsEvents, analyticsDesktopHeaderEvents } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { useEmployerHeaderContext, testTags } from "../../EmployerHeader.mjs";
import { URL_DASHBOARD, URL_ROOT, URL_CREATE_NEW_JOB, URL_ACCOUNT_REGISTRATION } from "@seek/adv-constants";
import { isAuthenticated } from "../../../EmployerFooter/EmployerFooter.mjs";
import { ScreenReaderOnly } from "../ScreenReaderHelpers/ScreenReaderOnly.mjs";
import { translations } from "../../../../EmployerHeader/components/BrandedLogo/.vocab/index.mjs";
import { thaiMarginTop, nonThaiMarginTop, container, link, logo, brandName } from "./BrandedLogo.css.mjs";
const getRootPath = (authenticationStatus) => {
  if (isAuthenticated(authenticationStatus)) {
    return URL_DASHBOARD;
  }
  return URL_ROOT;
};
const getCtaPath = (authenticationStatus) => {
  if (isAuthenticated(authenticationStatus)) {
    return URL_CREATE_NEW_JOB;
  }
  return URL_ACCOUNT_REGISTRATION;
};
const BrandedLogo = ({ linkRenderer: LinkRenderer }) => {
  const { t } = useTranslations(translations);
  const { language } = useLanguage();
  const { authenticationStatus, urlResolver, handleInteractionTracking } = useEmployerHeaderContext();
  const marginTop = language.startsWith("th") ? thaiMarginTop : nonThaiMarginTop;
  const rootURL = urlResolver({ path: getRootPath(authenticationStatus) });
  return /* @__PURE__ */ jsx(Box, { className: container, children: /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      href: rootURL,
      className: link,
      ...{
        "data-analytics": analyticsEvents.TRACK_LOGO,
        "data-testid": testTags.LOGO
      },
      onClick: () => {
        handleInteractionTracking(analyticsDesktopHeaderEvents.brandLogo);
      },
      children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", height: "full", children: [
        /* @__PURE__ */ jsx(Box, { className: logo, children: /* @__PURE__ */ jsx(Logo, { brand: "seek", size: "fill" }) }),
        /* @__PURE__ */ jsx(ScreenReaderOnly, { children: t("SEEK employer") }),
        /* @__PURE__ */ jsx(
          Box,
          {
            paddingLeft: "xxsmall",
            display: "block",
            component: "span",
            className: [brandName, marginTop],
            children: t("employer")
          }
        )
      ] })
    }
  ) });
};
export {
  BrandedLogo,
  getCtaPath
};
